import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Rail from './Rail';
import MobileTopBar from './MobileTopBar';

const Layout: React.FC = () => {
  const location = useLocation();

  // Don't show navigation on public pages
  const hideNav = ['/', '/login', '/register'].includes(location.pathname);

  if (hideNav) {
    return <Outlet />;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-background text-ink-900">
      {/* Persistent left rail — desktop only */}
      <Rail />

      {/* Content column */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Mobile top bar — only on small screens */}
        <MobileTopBar />

        {/* Scrollable content area */}
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;

